import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody,ButtonGroup} from 'reactstrap';
import * as http from '../../../modules/http';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import ChooseManager from './ChooseManager';
import AddStores from './AddStores'
import Modal from '../../../components/Modal';
import {fetchStoresByDayManager,prize_stores_day_manager_add} from '../../../redux/actions/PrizeActions';


const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class PrizeManagersTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            showConfigManagers: false,
            showConfigStore: false,
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 20
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchStoresByDayManager());
    }

    /*addStore = () => {
        const store = {id: 0, storeId: 0, storeName: '', soldNum: 0, goal: 0, prize: '', startDay: '', endDay: ''};
        this.props.dispatch(prize_open_update_form(store));
        this.setState({
            selectedID: 0, windowType: 2, error: false,
        });
    };*/

    chooseManager = (id, name) => {
        this.props.dispatch(prize_stores_day_manager_add(id,name));
        this.setState({manager: id, managerName: name,
            showConfigStore: !this.state.showConfigStore,
            showConfigManagers: !this.state.showConfigManagers})
    };

    editManager = (prize) => {
        if (prize.id === this.state.selectedID && this.state.windowType === 2) {
            this.setState({selectedID: 0, windowType: 0});
        }
        else {
            //this.props.dispatch(prize_open_update_form(prize));
            this.setState({selectedID: prize.id, windowType: 2, error: false});
        }
    };

    deletePrize = (prize) => {
        //abc
        http.postToServer(
            'prize/delete?id=' + prize.id,
            {},
            (response) => {
                //this.props.dispatch(prize_delete(this.props.day, prize.id));
            },
            (response) => {
                console.log('error delete prize');
            }
        );

    };

    getRow(prize, index, isDelete) {

        let length = 0;
        for(let index in prize.dayStores) {
            if(prize.dayStores[index].storesDay.includes(',')) {
                length = length + prize.dayStores[index].storesDay.split(',').length;
            }
            else if(prize.dayStores[index].storesDay !== '') {
                length = length + 1;
            }
        }
        //prize.dayStores.map((e) => length += e.storesDay.split(',').length);

        return (

            <React.Fragment key={prize.id}>

                <tr key={prize.id}>

                    {isDelete && <td>
                        <Modal color='danger' title='Are you sure!'
                               approve={() => this.deletePrize(prize)}
                               message={'Delete Prize for ' + prize.storeName + '?'}>
                            <Button color='danger' size='sm' onClick={(e) => e.preventDefault()}
                                    style={{padding: "0px 15px"}}>
                                <FontAwesome name='times'/>
                            </Button>

                        </Modal>
                    </td>}

                    <td>
                        <Button color='primary' size='sm'
                                style={{padding: "0px 15px"}}
                                onClick={() => this.editManager(prize)}>{TextManager.getCurrentTextResource().Text.edit}</Button>
                    </td>

                    <td>{length}</td>
                    <td>{prize.managerName}</td>
                    <td>{prize.managerId}</td>

                </tr>

                {this.state.windowType === 2 && prize.id === this.state.selectedID &&
                <tr key={prize.id + 2000}>
                    <td colSpan="7">
                        <AddStores manager={prize.managerId} managerName={prize.managerName} onClose={() => this.editManager(prize)}/>
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    render() {

        const {rowsPerPage, page} = this.state;

        const isDelete = this.props.userData && this.props.userData.data.isAdmin;

        var isAdding = !(!this.state.showConfigManagers && !this.state.showConfigStore);//this.state.windowType === 2 && this.state.selectedID === 0;

        let rows = [];
        let length = 0;

        if(this.props.data && this.props.data !== undefined) {
            length = this.props.data.length;
            rows = this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((prize, index, isDelete) =>
                this.getRow(prize,index, isDelete)
            );
        }

        //console.log(this.props.data)

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>
                    <CardBody>

                        {!isAdding &&
                        <span>
                            <Table responsive className='table--bordered'>
                                <thead>
                                    <tr>

                                        {isDelete && <th>
                                            {<Button color='primary' size='sm'
                                                     style={{padding: "0px 15px", margin: "0px"}}
                                                     //onClick={() => this.addManager()}
                                                      onClick={() => this.setState({showConfigManagers: !this.state.showConfigManagers})}>
                                                <FontAwesome name='plus-square' style={{marginLeft: "5px"}}/>
                                            </Button>}

                                        </th>}

                                        <th></th>

                                        <th>כמות חנויות</th>
                                        <th>שם מנהל</th>
                                        <th>מספר מנהל</th>

                                        <th></th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {rows}
                                </tbody>
                            </Table>
                            <Row>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <CustomPagination
                                        labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                        rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
                                        component="div"
                                        count={length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </Col>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <ButtonGroup className='btn-group--icons'
                                                 style={{marginTop: "10px", float: "right"}}>
                                        <Button outline color='primary'
                                                onClick={() => this.props.onClose()}>Go Back</Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </span>}

                        {this.state.showConfigManagers &&
                            <ChooseManager onClose={() => this.setState({showConfigStore: false, showConfigManagers: false})}
                                       chooseManager={this.chooseManager}/>
                        }

                        {this.state.showConfigStore &&
                            <AddStores manager={this.state.manager} managerName={this.state.managerName}
                               onClose={() => this.setState({showConfigStore: !this.state.showConfigStore})}/>
                        }

                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.prize.storesDayManager,
        status: state.prize.status,
        utilsData: state.utilsData,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(PrizeManagersTable))